/**
 * @module Filters
 * @description Some handy filters
 */

/**
 * @function stringify
 * @description Filter for Tagular Payload Object
 */
export const stringify = ( str: string|{} ) => JSON.stringify( str );

/**
 * @function onlySpaces
 * @description Check if string is only spaces
 */
export const onlySpaces = ( str: string ) => str.trim().length === 0;

/**
 * @function filterNone
 * @description Filter for Preamp Metadata where the value is set to "__none__"
 */
export const filterNone = ( array: string[] ) => array.filter( item => item !== '__none__' );

export default stringify;
